import React from "react";
import PropTypes from "prop-types";
import styles from "./IntroduccioIndividuFenofasesDetallValor.module.css";
import { Icon } from "antd";

class IntroduccioIndividuFenofasesDetallValor extends React.Component {
  iconMode = () => {
    const {
      type,
      observacioActual,
      handleObservacio,
      valorDefecte
    } = this.props;

    const newType = !observacioActual.valorActual
      ? type
      : type === "check" && observacioActual.valorActual === 1
        ? "check-circle"
        : type === "close" && observacioActual.valorActual === 2
          ? "close-circle"
          : type === "question" && observacioActual.valorActual === 3
            ? "question-circle"
            : type;

    if (newType === type) {
      return (
        <Icon
          type={type}
          className={styles.icona}
          onClick={() => handleObservacio(valorDefecte)}
        />
      );
    } else {
      return (
        <Icon
          type={newType}
          theme="twoTone"
          className={styles.icona_activada}
          onClick={() => handleObservacio(valorDefecte)}
        />
      );
    }
  };

  render() {
    return (
      <div role="button" tabIndex="0" className={styles.icona_contenidor}>
        {this.iconMode()}
      </div>
    );
  }
}

IntroduccioIndividuFenofasesDetallValor.propTypes = {
  handleObservacio: PropTypes.func,
  observacioActual: PropTypes.object,
  valorNou: PropTypes.number,
  type: PropTypes.string
};

export default IntroduccioIndividuFenofasesDetallValor;
